import React from 'react';
import { Icon } from 'antd';

export const CashReturnIcon = props => (<div title="Reconciliation Return"><Icon type="dollar"/><Icon type="arrow-right" /></div>);
export const CashPickupIcon = props => (<div title="Payment Pickup"><Icon type="arrow-left" /><Icon type="dollar"/></div>);
// Rejection Return — distinct from Reconciliation Return per Joel 2026-05-26.
// Uses the rollback arrow to convey "order coming back after rejection".
export const RejReturnIcon = props => (<div title="Rejection Return" style={{ display: 'inline-block' }}><Icon type="rollback" style={{ color: '#cf1322' }} /></div>);